export default __webpack_public_path__ + "static/media/backButton.68794a49.webp";